var config = {
  // baseOAuthUrl: "http://192.168.0.58:8888/",
  userAuthorizationUri: "/college_service_hall_api/oauth2/authorize", // 请求授权地址
  accessTokenUri: "/oauth2Api/oauth/token", // accessToken请求地址
  userInfoUri: "/college_service_hall_api/oauth2/userinfo", // 用户信息请求地址
  // logoutUri: "http://192.168.0.58:8888/logout", // 登出请求地址
  localuri: "http://192.168.0.53:8082", // 项目地址
  redirect_uri: "", // 案例资源服务器地址
  // resUri: "http://192.168.0.58:8888", // 客户端相关标识，请从认证服务器申请
  clientId: "",
  // client_secret: "esdf3234",
  scope: "all", // 申请的权限范围
  state: "", // 可选参数，客户端的当前状态，可以指定任意值，用于校验
  response_type: "code", // 一些固定的请求参数
  grant_type: "authorization_code",
  code: "",
};

export default config;
